//Import Js
import responsiveTables from './components/responsiveTables';
import resizeGalleryImages from './components/resizeGalleryImages';
import setupLightbox from './components/lightBox';

// Call the functions
window.addEventListener('load', responsiveTables);
document.addEventListener('DOMContentLoaded', resizeGalleryImages);
document.addEventListener('DOMContentLoaded', setupLightbox);